import { selector, selectorFamily } from 'recoil';

import { getSiteSubsidiary } from '@bo-utils/siteUtils';
import { allSubsidiaryState, menusState, siteState, subsidiaryState } from './atom';

export const withMenus = selector({
  key: 'withMenus',
  get: ({ get }) => {
    const { menus } = get(menusState);
    return menus;
  },
});

export const withMenuGroups = selector({
  key: 'withMenuGroups',
  get: ({ get }) => {
    const { menuGroups } = get(menusState);
    return menuGroups;
  },
});

export const withBookmarkMenus = selector({
  key: 'withBookmarkMenus',
  get: ({ get }) => {
    const { bookmarkMenus } = get(menusState);
    return bookmarkMenus;
  },
  set: ({ get, set }, newBookmarkMenus) => {
    set(menusState, { ...get(menusState), bookmarkMenus: newBookmarkMenus });
  },
});

export const withMenu = selectorFamily({
  key: 'withMenu',
  get:
    (menuNumber) =>
    ({ get }) => {
      const { menus } = get(menusState);
      return menus[menuNumber] ? menus[menuNumber] : {};
    },
  set:
    (menuNumber) =>
    ({ set, get }, newMenu) => {
      const { menus, ...rest } = get(menusState);
      set(menusState, { ...rest, menus: { ...menus, [menuNumber]: newMenu } });
    },
});

export const withMenuUrl = selectorFamily({
  key: 'withMenuUrl',
  get:
    (menuUrl) =>
    ({ get }) => {
      const { menuUrls, menus } = get(menusState);
      return menus[menuUrls[menuUrl]];
    },
});

export const withSiteSubsidiary = selector({
  key: 'withSiteSubsidiary',
  get: ({ get }) => {
    const subsidiaries = get(subsidiaryState);

    return subsidiaries?.reduce((siteSubsidiary, subsidiary) => {
      (siteSubsidiary[subsidiary.siteNumber] = siteSubsidiary[subsidiary.siteNumber] || []).push(subsidiary);
      return siteSubsidiary;
    }, {});
  },
});

export const withAllSiteSubsidiary = selector({
  key: 'withAllSiteSubsidiary',
  get: ({ get }) => {
    const subsidiaries = get(allSubsidiaryState);

    return subsidiaries?.reduce((siteSubsidiary, subsidiary) => {
      (siteSubsidiary[subsidiary.siteNumber] = siteSubsidiary[subsidiary.siteNumber] || []).push(subsidiary);
      return siteSubsidiary;
    }, {});
  },
});

export const withSiteList = selector({
  key: 'withSiteList',
  get: ({ get }) => get(siteState).map?.((site) => ({ ...site, itemLabel: site.siteName })),
});

export const withSiteSubsidiaryList = selector({
  key: 'withSiteSubsidiaryList',
  get: ({ get }) => {
    const subsidiaries = get(subsidiaryState);

    return getSiteSubsidiary(subsidiaries);
  },
});
